import * as React from "react";
import {RouteComponentProps} from "react-router-dom";
import {connect} from "react-redux";
import {useLocation} from "react-router-dom";
import {IReduxState} from "reducers";
import ContainerBox from "myshubhlife-component/container-box";
import {COLOR} from "utils/variables";
import {applyUrl} from "config";
import {getLatestApplicationStatus} from "profile/api";
import {useEffect} from "react";
import {ApplicationStatus, ApplicationSubStatus} from "profile/enums";
import Timer from "myshubhlife-component/timer";
import {setLatestApplicationStatus} from "profile/actions";

interface IConnectProps {
    dispatch?: (action: any) => void;
    isAndroid: boolean;
    userId: number;
    utm_source?: string;
}
const redirectLink = {
    incompleteInfo: `${applyUrl}#/incomplete-info`,
    bankStatement: `${applyUrl}#/incomplete-info/bank-statement`,
};
const defaultMsg = "We are processing your Bank statement";
const errorMsg = "Sorry we are unable to process your Bank statement";
const BankStatementRedirect = (props: IConnectProps & RouteComponentProps) => {
    const urlParams = new URLSearchParams(useLocation().search);
    const status = urlParams.get("success");
    const isError = status === "false";
    const aggregatorDetails = JSON.parse(sessionStorage.getItem("aggregator_details"));

    useEffect(() => {
        const interval = setInterval(() => {
            getLatestApplicationStatus().then((res) => {
                props.dispatch(setLatestApplicationStatus(res));
                if (
                    (res.status && res.status === ApplicationStatus.INITIATED) ||
                    (
                        res.subStatuses && !(res.subStatuses.includes(ApplicationSubStatus.BS_6M_MISSING) ||
                        res.subStatuses.includes(ApplicationSubStatus.BS_SALARY_MISSING) ||
                        res.subStatuses.includes(ApplicationSubStatus.BS_NET_BANKING))
                    )
                ) {
                    redirectToNextPage();
                }
            });
        }, 30000);
        return () => {
            clearInterval(interval);
        };
    }, []);
    const onTimeOut = () => {
        redirectToNextPage();
    };
    const redirectToNextPage = () => {
        if (aggregatorDetails) {
            return window.location.href = redirectLink.bankStatement;
        }
        window.location.href = redirectLink.incompleteInfo;
    };
    return (
        <ContainerBox backgroundColor={COLOR.GRAY_BG}>
            <Timer utm_source={props.utm_source} duration={isError ? 5 : 90} text={isError ? errorMsg : defaultMsg} onFinish={onTimeOut}/>
        </ContainerBox>
    );
};

const mapStateToProps = (state: IReduxState): IConnectProps => {
    return {
        isAndroid: state.login.isAndroid,
        userId: state.login.auth.userId,
        utm_source: state.login.authExt && state.login.authExt.utm_source ? state.login.authExt.utm_source : null,
    };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(BankStatementRedirect);
